//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SelectUserModal from '../common-components/select-user-modal';

export default {
    name: 'staff',
    components: { SelectUserModal },
    data() {
        return {
            title: '新增客服',
            showCreateModal: false,
            createStaffDto: {},
            list: [],
            rules: {
                reportNum: [{ required: true, message: '请输入工号', trigger: 'blur' }]
                // { type: 'number', min: 2001, message: '工号位于2001-999999之间', trigger: 'change' }]
                // { required: true, message: 'The name cannot be empty', trigger: 'blur' }
            },
            columns: [
                { type: 'index', width: 66, align: 'center' },
                { title: '工号', align: 'center', key: 'reportNum' },
                { title: '用户', align: 'center', key: 'userName' },
                { title: '操作', slot: 'action', align: 'center' }
            ],
            showCreateUserModal: false,
            saving: false,
            loading: false,
            currentPage: 1,
            totalCount: 0,
            pageSize: 10
        };
    },
    methods: {
        pageChange(page) {
            this.currentPage = page;
            this.getPage();
        },
        pageSizeChange(size) {
            this.pageSize = size;
            this.getPage();
        },
        getPage() {
            this.loading = true;
            const page = {
                maxResultCount: this.pageSize,
                skipCount: (this.currentPage - 1) * this.pageSize
            };
            abp.ajax.post('/api/services/app/CallLogs/SearchStaffs', page).then(res => {
                this.list = [];
                this.list.push(...res.data.result.items);
                this.totalCount = res.data.result.totalCount;
            }).finally(() => {
                this.loading = false;
            });
        },
        selectedUser(user) {
            // console.log(user);
            this.showCreateUserModal = false;
            this.createStaffDto.userName = user.name;
            this.createStaffDto.userId = user.id;
        },
        onSave() {
            const vm = this;
            if (!vm.createStaffDto.userId) {
                vm.$Message.error('请选择用户');
                return;
            }
            // if (vm.createStaffDto.reportNum < 2001) {
            //     vm.$Message.error('工号位于2001-999999之间');
            //     return;
            // }
            this.$refs.form.validate(valid => {
                if (valid) {
                    vm.saving = true;
                    abp.ajax.post('/api/services/app/CallLogs/SaveCustomerServiceStaff', vm.createStaffDto).then(() => {
                        vm.showCreateModal = false;
                        this.$Notice.success({
                            duration: 3,
                            title: '提示',
                            desc: '保存成功'
                        });
                        vm.getPage();
                    }).finally(() => {
                        vm.saving = false;
                    });
                }
            });
        },
        show(r) {
            // this.$refs.form.resetFields();
            this.createStaffDto = {
                id: 0,
                reportNum: 2001
            };
            this.createStaffDto = JSON.parse(JSON.stringify(r));

            if (this.createStaffDto.id > 0) {
                this.title = '编辑客服人员';
                this.createStaffDto.reportNum = parseInt(this.createStaffDto.reportNum);
            } else {
                this.title = '新增客服人员';
            }
            this.showCreateModal = true;
        },
        handleCancel() {
            this.$refs.form.resetFields();
            this.showCreateModal = false;
        },

        handleDel(row) {
            this.$Modal.confirm({
                title: this.L('Tips'),
                content: '确定删除?',
                okText: this.L('Yes'),
                cancelText: this.L('No'),
                onOk: () => {
                    this.delete(row.id);
                }
            });
        },
        delete(id) {
            abp.ajax.delete('/api/services/app/CallLogs/DeleteStaff?id=' + id).then(() => {
                this.$Notice.success({
                    duration: 3,
                    title: '通知',
                    desc: '删除成功'
                });
                this.getPage();
            }).finally(() => {

            });
        }
    },
    created() {
        this.getPage();
    }
};
